<template>
  <div class="value margin-between-section">
    <div class="row not-margin">

      <div class="col-lg-6 col-md-12 not-padding container-info-form mobile">
        <div class="row form">
          <div class="col-md-6 col-md-12 not-padding">
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_age') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="edad" maxlength="2" type="text" id="id1"  :placeholder="$t('home.placeholder_value_age') " />
            </div>
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_time') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="tiempo" maxlength="2" type="text" id="id1"  :placeholder="$t('home.placeholder_value_time')" />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
            <label for="id1">{{ $t('notification.calculate_goles') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="goles" maxlength="3" type="text" id="id1"  :placeholder="$t('home.placeholder_value_goals')" />
            </div>
            <div class="con-i">
            <label for="id1">{{ $t('notification.calculate_cost') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="costo" type="text" id="id1"  :placeholder="$t('home.placeholder_value_cost')"/>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_minutes') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="minutos" maxlength="3" type="text" id="id1"  :placeholder="$t('home.placeholder_value_minutes')" />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
              <label for="id1">{{ $t('admin.select_postions_value') }}:</label><br>
              <div class="dropdown f-l">
                <template class="btn-d">
                  <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                  <select v-else v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positions" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>
          <!--<div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
              <label for="id1">{{ $t('admin.select_postions_ofe') }}:</label><br>
              <div class="dropdown f-l">
                <template class="btn-d">
                  <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsOfeEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                  <select v-else v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsOfe" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>-->
          <div class="col-md-12">
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_value') }}: -</label><br>
              <input type="hidden"  id="id1" :value="'$ ' + valuePlayerText + ''"/>
              <p class="t-righ input-estimate" >From 
                <span v-if="valorFuturoA == '-' && valorFuturoB == '-'">$ xxx,xxx.xx'</span>
                <span v-else>${{valorFuturoA}} to ${{valorFuturoB}} </span>
              </p>
              <!--<small class="cal-cul">{{$t('notification.range') }}: +/- 1.5</small>-->
            </div>
          </div>
          <div class="col-md-12 text-copy-right">
            <p>{{ $t('home.avise_cal') }}</p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 container-info">
        <div class="info">
          <h1>{{ $t('home.value_title') }}</h1>
          <p>{{ $t('home.value_txt') }}</p>
          <p>{{ $t('home.value_txt2') }}</p>
          
        </div>
      </div>

      <div class="col-lg-6 col-md-12 not-padding container-info-form desktop">
        <div class="row form">
          <div class="col-md-6 not-padding">
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_age') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="edad" maxlength="2" type="text" :placeholder="$t('home.placeholder_value_age')" />
            </div>
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_time') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="tiempo" maxlength="2" type="text" :placeholder="$t('home.placeholder_value_time')" />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
            <label for="id1">{{ $t('notification.calculate_goles') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="goles" maxlength="3" type="text" :placeholder="$t('home.placeholder_value_goals')" />
            </div>
            <div class="con-i">
            <label for="id1">{{ $t('notification.calculate_cost') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="costo" type="text" :placeholder="$t('home.placeholder_value_value')" />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 not-padding recon-position">
            <div class="col-lg-6 padding-none">
              <label for="id1">{{ $t('notification.calculate_minutes') }}: -</label><br>
              <input @keypress="isNumber($event)" v-model="minutos" maxlength="3" type="text" id="id1" :placeholder="$t('home.placeholder_value_minutes')" />
            </div>
          </div>
          <div class="col-lg-10 col-md-12 not-padding recon-position">
            <div class="con-i">
              <label for="id1">{{ $t('admin.select_postions_value') }}:</label><br>
              <div class="dropdown f-l">
                <template class="btn-d">
                  <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                  <select v-else v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positions" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>
          <!--<div class="col-lg-6 col-md-12 not-padding recon-position">
            <div class="con-i">
              <label for="id1">{{ $t('admin.select_postions_ofe') }}:</label><br>
              <div class="dropdown f-l">
                <template class="btn-d">
                  <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsOfeEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                  <select v-else v-model="position" class="browser-default custom-select btn-d">
                    <option v-for="item in positionsOfe" :key="item.id" :value=item.value >{{item.position}}</option>
                  </select>
                </template>
              </div>
            </div>
          </div>-->
          <div class="col-md-12 t-righ">
            <div class="con-i">
              <label for="id1">{{ $t('notification.calculate_value') }}: -</label>
              <input type="hidden"  id="id1" :value="'$ ' + valuePlayerText + ''"/>
              <p class="t-righ input-estimate" >From 
                <span v-if="valorFuturoA == '-' && valorFuturoB == '-'">$ xxx,xxx.xx'</span>
                <span v-else>${{valorFuturoA}} to ${{valorFuturoB}} </span>
              </p>
              <br>
              <!--<small class="cal-cul">{{$t('notification.range') }}: +/- 1.5</small>-->
            </div>
          </div>
          <div class="col-md-12 text-copy-right">
            <p>{{ $t('home.avise_cal') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'value',
  data() {
    return {
      //valuePlayerText = "xxx,xxx.xx",
      goles: "",
      edad: "",
      costo: "",
      tiempo: "",
      minutos: "",
      position: 0,
      valorFuturoA: "-",
      valorFuturoB: "-",
      positionsEsp: [
        { position: "Jugador Defensivo (DFC, LI, LD, CRI, CRD, MD) ", value: 0 },
        { position: "Jugador Ofensivo (EXD, EXI, MO, DEL) ", value: 1 },
        /*{ position: "LB", value: 1 },
        { position: "RB", value: 1 },
        { position: "LWB", value: 1 },
        { position: "RWB", value: 1 },
        { position: "DM", value: 1 },
        { position: "LM", value: 1 },
        { position: "CM", value: 0 },
        { position: "RM", value: 1 },
        { position: "AM", value: 1 },
        { position: "S", value: 1 }*/
      ],
      positionsOfe: [
        { position: "LM", value: 1 },
        { position: "CM", value: 0 },
        { position: "RM", value: 1 },
        { position: "AM", value: 1 },
        { position: "S", value: 1 }
      ],
      positionsDefEsp: [
        { position: "DFC", value: 0 },
        { position: "LI", value: 1 },
        { position: "LD", value: 1 },
        { position: "CRI", value: 1 },
        { position: "CRD", value: 1 },
        { position: "MD", value: 1 },
      ],
      positions: [
        { position: "Defensive Player (CB, LB, RB, LWB, RWB, DM) ", value: 0 },
        { position: "Attacking Player (AM, LM, RM, S) ", value: 1 },

        /*{ position: "DFC", value: 0 },
        { position: "LI", value: 1 },
        { position: "LD", value: 1 },
        { position: "CRI", value: 1 },
        { position: "CRD", value: 1 },
        { position: "MD", value: 1 },
        { position: "EXD", value: 1 },
        { position: "MC", value: 0 },
        { position: "EXI", value: 1 },
        { position: "MO", value: 1 },
        { position: "DEL", value: 1 }*/
      ],
    }
  },
  watch: {
    edad: function (val) {
      this.edad = val
    },
    goles: function (val) {
      this.goles = val
    },
    tiempo:  function (val) {
      this.tiempo = val
    },
    costo:  function (val) {
      this.costo = val
    },
    minutos:  function (val) {
      this.minutos = val
    },
    position: function(val){
      this.position = val
    }
  },
  computed: {
    // a computed getter
    valuePlayerText: function () {

      //Edad salida: ed
      //Valor actual: va
      //Goles cada 90: g
      //Tiempo en el equipo: t
      //Position: p

      const ed = this.edad
      const va = this.costo
      const g = this.goles
      const mj = this.minutos
      const t = this.tiempo
      const p = this.position
    
      const step0 = -93.06375 * 1

      const step1 = -9.21533 * ed
      
      const step2 = 0.9461015 * (ed ** 2)
      
      const step3 = -0.0167813 * (ed ** 3)

      const step4 = 0.51264 * va

      const step5 = -0.003190572 * (ed * va)

      const step6 = 0.01005511 * ((ed ** 2) * va)

      const step7 = -0.2136331 * (va ** 2)

      const step8 = 0.02435887 * (ed * (va ** 2))

      const step9 = -0.01660457 * (va ** 3)
      
      const step10 = -347.0811 * g

      const step11 = 15.7857 * (ed * g)

      const step12 = -0.2224389 * ((ed ** 2) * g) 

      const step13 = -5.463442 * (va * g)

      const step14 = -0.221211 * (ed * va * g )

      const step15 = 0.4946073 * ((va ** 2) * g)

      const step16 = -253.4757 * (g ** 2)

      const step17 = -3.288398 * (ed * (g ** 2))

      const step18 = -0.7072183 * (va * (g ** 2))

      const step19 = 51.00092 * (g ** 3)

      const step20 = 3.903226 * mj

      const step21 = -0.3334107 * (ed * mj)

      const step22 = 0.004741693 * ((ed ** 2) * mj)

      const step23 = -0.05258241 * (va * mj)

      const step24 = -0.009549707 * (ed * va * mj)

      const step25 = 0.003305072 * ((va ** 2) * mj)

      const step26 = 1.513651 * (g * mj) 

      const step27 = 0.04829708 * (ed * g * mj) 

      const step28 = 0.1893148 * (va * g * mj) 
      
      const step29 = 1.723887 * ((g ** 2) * mj) 

      const step30 = 0.02251543 * (mj ** 2)
      
      const step31 = 0.0004817819 * (ed * (mj ** 2))

      const step32 = 0.001858747 * (va * (mj ** 2)) 

      const step33 = -0.007977845 * (g * (mj ** 2)) 

      const step34 = -0.000214256 * (mj ** 3) 

      const step35 = 115.6528 * t

      const step36 = -5.092706 * (ed * t)

      const step37 = 0.0549628 * ((ed ** 2) * t)

      const step38 = 1.745637 * (va * t) 

      const step39 = 0.03024749 * (ed * va * t)

      const step40 = -0.2430494 * ((va ** 2) * t)

      const step41 = -2.384678 * (g * t)

      const step42 = -1.326251 * (ed * g * t) 

      const step43 = 3.083756 * (va * g * t)

      const step44 = 17.01296 * ((g ** 2) * t)

      const step45 = -0.6070962 * (mj * t)

      const step46 = 0.0005691136 * (ed * mj * t)

      const step47 = -0.01184727 * (va * mj * t)

      const step48 = -0.2409825 * (g * mj * t)

      const step49 = 0.004400855 * ((mj ** 2) * t)

      const step50 = -8.667472 * (t ** 2)    

      const step51 = 0.455782 * (ed * (t ** 2))

      const step52 = -0.02189407 * (va * (t ** 2))

      const step53 = 7.122027 * (g * (t ** 2))

      const step54 = -0.03999681 * (mj * (t ** 2))
      
      const step55 = -0.04875619 * (t ** 3)

      const step56 = 139.4702 * p

      const step57 = -6.723016 * (ed * p)

      const step58 = 0.03932158 * ((ed ** 2) * p)

      const step59 = 6.878217 * (va * p)
      
      const step60 = -0.02156677 * (ed * va * p)

      const step61 = -0.2284307 * ((va ** 2) * p)

      const step62 = 294.5083 * (g * p)
      
      const step63 = -2.653231 * (ed * g * p)
      
      const step64 = -13.96851 * (va * g * p)

      const step65 = 115.4244* ((g ** 2) * p)

      const step66 = -1.436124 * (mj * p)

      const step67 = 0.04597876 * (ed * mj * p)
      
      const step68 = -0.02646562 * (va * mj * p)
      
      const step69 = -2.548188 * (g * mj * p)
      
      const step70 = 0.001253137 * ((mj ** 2) * p)
      
      const step71 = -16.60522 * (t * p)
      
      const step72 = 0.5718988 * (ed * t * p)
      
      const step73 = -0.7264003 * (va * t * p)
      
      const step74 = 0.8484113 * (g * t * p)
      
      const step75 = 0.1739075 * (mj * t * p)
      
      const step76 = -2.198908 * ((t ** 2) * p) 

      const subtotal = Math.round((step0 + step1 + step2 + step3 + step4 + step5 + step6 + step7 + step8 + step9 + step10  + step11 + step12 + step13 + step14 + step15 + step16 + step17 + step18 + step19 + step20 + step21 + step22 + step23 + step24 + step25 + step26 + step27 + step28 + step29 + step30 + step31 + step32 + step33 + step34 + step35 + step36 + step37 + step38 + step39 + step40 + step41 + step42 + step43 + step44 + step45 + step46 + step47 + step48 + step49 + step50 + step51 + step52 + step53 + step54 + step55 + step56 + step57 + step58 + step59 + step60 + step61  + step62 + step63 + step64 + step65 + step66 + step67 + step68 + step69 + step70 + step71 + step72 + step73 + step74 + step75 + step76) * 100) / 100

      let result = subtotal


      const valorFA = (result - 0.5) * va
      const valorFB = (result + 0.5) * va
      
      this.info(valorFA, valorFB)

      if(parseInt(result) < 0){
        result = 'xxx,xxx.xx'
      }

      return result
    }
  },
  methods: {
    info(valorFA, valorFB){

      this.valorFuturoA = Math.round(valorFA * 100) / 100

      if(parseInt(this.valorFuturoA) < 0){
        this.valorFuturoA = 0
      }

      this.valorFuturoB = Math.round(valorFB * 100) / 100

      if(parseInt(this.valorFuturoB) < 0){
        this.valorFuturoB = 0
      }

    },
    
    isNumber(event) {

      const keycode = event.which
      
      if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
        event.preventDefault();    
      } else {
        return true
      }
    },

    formatPrice(value) {
        const val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.padding-none{
  margin: 0;
  padding: 0;
}
.cal-cul{
  font-size: 10px;
}

.text-copy-right{
  text-align: left;
  font-size: 8px;
}

.t-righ{
  text-align: right;
}

.desktop{
  display: block;
}

.mobile{
  display: none !important;
}

.info{
  text-align: left;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial;
  color: #fff;
}

.info p{
  padding-top: 1%;
  font-size: 15px;
  color: #fff;
}

.container-info{
  display: flex;
  align-items: center;
}

.container-info-form{
  display: flex;
  align-items: center;
  justify-content: center;
}

.form{
  padding: 5%;
  margin: 5% 0;
  background: #fff;
  text-align: left;
}

.form label{
  font-size: 12px;
  font-family: 'plain medium', arial;
  min-height: 33px;
}

.form input{
  font-size: 12px;
  font-family: 'plain medium', arial;
  border: 0;
  border-bottom: 1px solid #000;
  width: 90%;
}

.form .input-estimate{
  width: 40%;
  font-size: 13px;
  font-family: 'plain medium', arial;
  border: 0;
  border-bottom: 1px solid #000;
  display: inline-block;
}

.form .input-estimate span{
  font-family: 'plain medium', arial;
}

.con-i{
  margin: 6% 0;
}

.not-margin{
  margin: 0;
}

.not-padding{
  padding: 0;
}

.value{
  background: url('../assets/images/proyeccion.png');
  background-size: cover;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 992px) {

  .con-i{
    margin: 0 0 2% 0;
  }

  .con-i input{
    width: 70%;
  }

  .info{
    padding-bottom: 50px;
  }

  .info p{
    font-size: 16px;
  }

  .info h1{
    padding-top: 20px;
  }
  .not-padding{
    padding: 15px;
  }
  .form .input-estimate{
    width: 100%;
  }
}

/* Larger than tablet */
@media (max-width: 768px) {

  .con-i{
    margin: 6% 0;
  }

  .con-i input{
    width: 100%;
  }

  .info p{
    font-size: 15px;
    line-height: 22px;
  }

  .desktop{
    display: none;
  }

  .mobile{
    display: block !important;
  }

  .not-padding{
    padding: 15px;
  }
}

/* Larger than phablet */
@media (max-width: 550px) {
  .info p{
    font-size: 14px;
    margin-bottom: 30px;
  }

  .img-about{
    display: none;
  }

  .recon-position{
    margin-top: -50px
  }
  .con-i input{
    width: 100%;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {}



</style>
